import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { DEFAULT_LEVELS } from '@/lib/levels';

export interface Level {
  id: string;
  name: string;
  category: string | null;
  description: string | null;
  sort_order: number;
  active: boolean;
}

export function useLevels() {
  const [levels, setLevels] = useState<Level[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchLevels = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error: fetchError } = await supabase
        .from('zehrahoca_levels')
        .select('*')
        .eq('active', true)
        .order('sort_order', { ascending: true });
      if (fetchError) throw fetchError;
      setLevels((data ?? []) as Level[]);
    } catch (err) {
      setError((err as Error).message);
      setLevels([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLevels();
  }, [fetchLevels]);

  return { levels, loading, error, refetch: fetchLevels };
}

export function activeLevelNames(levels: Level[]): string[] {
  const names = levels.filter((l) => l.active).map((l) => l.name);
  if (names.length > 0) return names;
  return DEFAULT_LEVELS.map((l) => l.name);
}